import { useState } from 'react';
import DesignSystemPage from './pages/DesignSystemPage';

type Tab = 'tokens' | 'primitives' | 'composites';

/**
 * FoundryPreviewApp — standalone surface for previewing the Foundry design
 * system. Mounted at `?surface=foundry`. Lives outside the OS shell so it
 * cannot be polluted by legacy tokens or surface theming.
 */
export default function FoundryPreviewApp() {
  const [tab, setTab] = useState<Tab>('tokens');

  return (
    <div className="min-h-[100dvh] bg-fd-bg text-fd-text font-geist antialiased">
      <header className="sticky top-0 z-10 flex h-14 items-center gap-4 border-b border-fd-border bg-fd-bg/90 px-8 backdrop-blur">
        <div className="flex items-center gap-2.5">
          <div
            className="grid h-5 w-5 place-items-center rounded-md text-[12px] font-bold text-fd-bg"
            style={{
              background: 'linear-gradient(135deg, var(--fd-accent), oklch(0.66 0.18 50))',
              boxShadow: '0 0 0 1px var(--fd-accent-line), 0 8px 24px -10px var(--fd-accent)',
            }}
          >
            A
          </div>
          <div className="leading-tight">
            <div className="text-[13px] font-semibold tracking-[-0.01em]">AI Brand Lab</div>
            <div className="font-geist-mono text-[10px] uppercase tracking-[0.06em] text-fd-text-subtle">
              Foundry · design system
            </div>
          </div>
        </div>

        <nav className="ml-6 flex items-center gap-1">
          {(['tokens', 'primitives', 'composites'] as const).map((t) => (
            <button
              key={t}
              onClick={() => setTab(t)}
              className={[
                'h-7 px-3 rounded-fd-sm font-geist text-[12.5px] font-medium transition-colors',
                tab === t
                  ? 'bg-fd-surface-2 text-fd-text shadow-[inset_0_0_0_1px_var(--fd-border)]'
                  : 'text-fd-text-muted hover:text-fd-text hover:bg-fd-surface-1',
              ].join(' ')}
            >
              {t[0].toUpperCase() + t.slice(1)}
            </button>
          ))}
        </nav>

        <div className="ml-auto font-geist-mono text-[10.5px] uppercase tracking-[0.06em] text-fd-text-subtle">
          v0.1 · 2026-04-26 · ?surface=foundry
        </div>
      </header>

      <main className="mx-auto max-w-[1280px] px-8 py-10">
        <DesignSystemPage tab={tab} />
      </main>
    </div>
  );
}
